module.exports = __webpack_public_path__ + "static/media/GBR.ff88b861.jpg";